import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Router, UrlTree } from "@angular/router";

import { AuthService } from "../services/auth.service";
import { Logger } from "src/app/core/logger/logger.service";

@Injectable()
export class AuthoritiesGuard implements CanActivate {
  log = new Logger("AuthAuthorities");
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const token = localStorage.getItem("jwt");
    const role = AuthService.jwtDecode(token);
    if (token) {
      if (role.roles.includes("gods")) {
        this.log.debug("access granted");
        return true;
      }
      this.log.debug("access denied");
      return this.router.createUrlTree(["/login"]);
    }
    return false;
  }
}
